import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/discovery/saveAlert';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { goalId, alertId, data } = action?.payload || {};
    const response = alertId
      ? yield call(
        axios.put,
        `${config.API_URL}/goals/${goalId}/alerts/${alertId}`,
        data,
        { headers: getLocalUser() },
      )
      : yield call(
        axios.post,
        `${config.API_URL}/goals/${goalId}/alerts`,
        data,
        { headers: getLocalUser() },
      );
    yield put(fetchSuccess({
      alertId: alertId || null,
      ...(response?.data?.data ?? {}),
      at: Date.now(),
    }));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
